import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'iq-central-front-end-add-course-module-four',
  templateUrl: './edit-quiz.component.html',
  styleUrls: ['./edit-quiz.component.scss']
})
export class EditQuizComponent implements OnInit {
  lessonDetails: any;
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.lessonDetails = data['resolvedData'].responseResult;
      console.log(this.lessonDetails);
    });
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }
}
